import { create } from "zustand";

export interface Toast {
  id: string;
  /** "success" | "error" | "info" — drives colour and default icon */
  kind: "success" | "error" | "info";
  title: string;
  body?: string;
  /** Optional click target shown as "View →"; closes the toast on navigate. */
  link?: { to: string; label: string };
  /** Auto-dismiss after this many ms. 0 / undefined → manual only. */
  ttl?: number;
}

interface ToastStore {
  toasts: Toast[];
  push: (t: Omit<Toast, "id"> & { id?: string }) => string;
  dismiss: (id: string) => void;
  clear: () => void;
}

export const useToasts = create<ToastStore>((set, get) => ({
  toasts: [],
  push: (t) => {
    const id = t.id ?? crypto.randomUUID();
    const toast: Toast = { ttl: 6000, ...t, id };
    set((s) => ({ toasts: [...s.toasts, toast] }));
    if (toast.ttl && toast.ttl > 0) {
      setTimeout(() => get().dismiss(id), toast.ttl);
    }
    return id;
  },
  dismiss: (id) =>
    set((s) => ({ toasts: s.toasts.filter((x) => x.id !== id) })),
  clear: () => set({ toasts: [] }),
}));
